import React, { memo } from 'react';
import { Box, Tooltip } from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { v1 } from 'uuid';
var FilterIcon = function () { return (React.createElement(Box, { display: "flex", p: 1 },
    React.createElement(Tooltip, { key: v1(), title: "This field is a search criteria" },
        React.createElement(FilterAltIcon, { color: "warning" })))); };
export default memo(FilterIcon);
//# sourceMappingURL=FilterIcon.js.map